import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const automox = defineConnector({
  identifier: "automox",
  name: "Automox",
  tagLine: "Automated endpoint patching",
  logo,
  protocol: "http",
  tags: ["it", "security"],
  defaultUrlPattern: () => "https://console\\.automox\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your Automox API key",
      items: [
        {
          kind: "markdown",
          content: `1. In Automox, go to **Settings › Keys**
2. Click **Create API Key**
3. Copy the key`,
        },
      ],
    },
    {
      title: "Enter your Automox details",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://console.automox.com/api/orgs?limit=1",
  },
});
